import { Injectable } from '@angular/core';
import { BehaviorSubject, timer, of } from 'rxjs';
import { switchMap, map, catchError, filter } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { DashboardService } from './dashboard.service';
import { NotificationWebSocketService } from './notification-websocket.service';

@Injectable({
  providedIn: 'root'
})
export class ApprovalCountService {
  private totalCountSubject = new BehaviorSubject<number>(0);
  public totalCount$ = this.totalCountSubject.asObservable();

  constructor(
    private authService: AuthService,
    private dashboardService: DashboardService,
    private notificationWebSocketService: NotificationWebSocketService
  ) {
    // Listen to reactive metrics stream
    this.dashboardService.metrics$.pipe(
      filter(metrics => !!metrics),
      map(metrics => metrics.approvalsCount || 0)
    ).subscribe(totalCount => {
      this.totalCountSubject.next(totalCount);
    });

    // Listen to real-time signals from WebSocket
    this.notificationWebSocketService.approvalCountSignals$.subscribe(signal => {
      const currentCount = this.totalCountSubject.value;
      if (signal === 'INCREMENT') {
        const newCount = currentCount + 1;
        this.totalCountSubject.next(newCount);
      } else if (signal === 'DECREMENT' && currentCount > 0) {
        const newCount = currentCount - 1;
        this.totalCountSubject.next(newCount);
      }
    });

    // Initial fetch and then poll every 5 minutes
    timer(0, 5 * 60 * 1000).pipe(
      filter(() => this.authService.isLoggedIn() && this.authService.isAdminOrHelpDesk()),
      switchMap(() => this.dashboardService.getMetrics().pipe(catchError(() => of(null))))
    ).subscribe();
  }

  refresh() {
    this.dashboardService.refreshMetrics();
  }
}
